const NAMESPACE = "headersEditor";

const KEYS = {
    addHeaderLabel: "addHeaderLabel",
    authorizationAlreadySetErrorMessage: "authorizationAlreadySetErrorMessage",
    clearHeadersLabel: "clearHeadersLabel",
    duplicateHeadersErrorMessage: "duplicateHeadersErrorMessage",
    emptyListText: "emptyListText",
    headerNameInputLabel: "headerNameInputLabel",
    headerValueInputLabel: "headerValueInputLabel",
    headerKeyColumnLabel: "headerKeyColumnLabel",
    headerReservedErrorMessage: "headerReservedErrorMessage",
    headerValueColumnLabel: "headerValueColumnLabel",
    invalidHeadersMessage: "invalidHeadersMessage",
    invalidHeaderValueMessage: "invalidHeaderValueMessage",
    parsingErrorMessage: "parsingErrorMessage"
};

const MESSAGES = {
    [KEYS.addHeaderLabel]: {
        value: "Add Header",
        comment: "Label for the Add Header button"
    },
    [KEYS.authorizationAlreadySetErrorMessage]: {
        value: 'Authorization header is already set by the "Authentication Type" setting above. Setting that to "None" will allow you to specify a custom Authorization header here.',
        comment: "Label for the Add Header button"
    },
    [KEYS.clearHeadersLabel]: {
        value: "Clear Headers",
        comment: "Label for the Clear Headers button"
    },
    [KEYS.duplicateHeadersErrorMessage]: {
        value: "Duplicate header",
        comment: "Error message for when duplicate headers are specified"
    },
    [KEYS.emptyListText]: {
        value: "No custom headers specified.",
        comment: "Message to show in the table of headers when it's empty"
    },
    [KEYS.headerNameInputLabel]: {
        value: "Header name",
        comment: "Label for the header name input"
    },
    [KEYS.headerValueInputLabel]: {
        value: "Header value",
        comment: "Label for the header value input"
    },
    [KEYS.headerKeyColumnLabel]: {
        value: "Key",
        comment: "Label for the header name column"
    },
    [KEYS.headerReservedErrorMessage]: {
        value: "This header is reserved and cannot be used here.",
        comment: "Error for when someone tries to set a header that is reserved (e.g., Content-Type)"
    },
    [KEYS.headerValueColumnLabel]: {
        value: "Value",
        comment: "Label for the header value column"
    },
    [KEYS.invalidHeadersMessage]: {
        value: "There are errors in the custom headers that need to be fixed.",
        comment: "Error message for invalid headers when headers are hidden"
    },
    [KEYS.invalidHeaderValueMessage]: {
        value: "Header values can only include letters, numbers, spaces, and -_={'@'}./\\",
        comment: "Error message for invalid headers that include invalid characters"
    },
    [KEYS.parsingErrorMessage]: {
        value: "The list of custom headers could not be parsed.",
        comment: "Error message for if somehow the JSON representation of the headers is invalid"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
